import { columns } from '../data';
import SectionHeader from './SectionHeader';

const toneMap = {
  primary: { box: 'bg-primary-100 text-primary-700', line: 'text-primary-600', btn: 'hover:border-primary-300 hover:bg-primary-50' },
  accent: { box: 'bg-accent-100 text-accent-700', line: 'text-accent-700', btn: 'hover:border-accent-300 hover:bg-accent-50' },
  secondary: { box: 'bg-secondary-100 text-secondary-800', line: 'text-secondary-700', btn: 'hover:border-secondary-300 hover:bg-secondary-50' },
};

export default function Columns() {
  return (
    <section id="column" className="scroll-mt-20 border-y border-background-200/70 bg-background-100/60 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <SectionHeader
          kicker="Columns"
          title="吃瓜常设栏目"
          desc="固定更新频率的编辑部栏目。订阅感十足，按自己关注的栏目定期追更，不遗漏任何精彩板块。"
        />
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          {columns.map((c) => {
            const t = toneMap[c.tone];
            return (
              <article
                id={`column-card-${c.id}`}
                key={c.id}
                className={`group flex scroll-mt-24 items-start gap-4 rounded-2xl border border-background-200/80 bg-background-50 p-5 transition ${t.btn}`}
              >
                <span className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl text-2xl ${t.box}`}>
                  <i className={c.icon} aria-hidden="true"></i>
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <h3 className="font-heading text-base font-bold text-foreground-950">{c.name}</h3>
                    <span className="rounded-full bg-background-200/80 px-2 py-0.5 text-xs text-foreground-500">{c.freq}</span>
                  </div>
                  <p className="mt-1 text-xs font-medium text-foreground-400">主理 · {c.host}</p>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-500">{c.desc}</p>
                  <div className="mt-3 flex flex-wrap items-center gap-3 text-xs">
                    <span className={`inline-flex items-center gap-1 font-semibold ${t.line}`}>
                      <i className="ri-eye-line" aria-hidden="true"></i>
                      {c.reads} 阅读
                    </span>
                    <span className="inline-flex items-center gap-1 text-foreground-400">
                      <i className="ri-article-line" aria-hidden="true"></i>持续连载
                    </span>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}